module.exports = __webpack_public_path__ + "img/img2.4e719d09.svg";